import { ConcernModel } from './Concern';
import { ConcernSummary } from '../../lib/context/ConcernsContext';
import { GetSocketDescription, GetSocketLink, GetSocketTitle } from '../importstatus/GetSocketDescription';
import ConvertConcernsStateToImportStatusSummary from '../importstatus/ConvertConcernsStateToImportStatusSummary';

export const ConcernSummaryUniqueKey = (x: ConcernModel) => `${x.Title}_${x.Description}_${x.Type}_${x.AccountId}`;

const ConvertConcernsStateToConcerns = (concernSummary: ConcernSummary) => {
  const output: ConcernModel[] = [...concernSummary.Concerns];
  const socketUpdates = ConvertConcernsStateToImportStatusSummary(concernSummary);
  concernSummary.Accounts.forEach((account) => {
    const rec = socketUpdates.find((x) => x.MPAccountId === account.Id && x.IsError);
    if (rec && !output.find((x) => x.AccountId === account.Id)) {
      const infoToUse = rec.Update?.Updates[0] || rec.Sync?.Updates[0] || rec.Update?.Updates[0];
      if (infoToUse) {
        output.push({
          Description: GetSocketDescription(infoToUse),
          Link: GetSocketLink({
            Code: infoToUse.Code,
            MarketplaceSource: infoToUse.MarketplaceSource,
            Links: account.Links
          }),
          Title: GetSocketTitle(infoToUse),
          AccountId: account.Id,
          Type: 'worker',
          Integration: infoToUse.MarketplaceSource,
          AccountName: account.Description
        });
      }
    }
  });

  return output.filter(
    (x, i, a) => a.findIndex((y) => ConcernSummaryUniqueKey(y) === ConcernSummaryUniqueKey(x)) === i
  );
};
export default ConvertConcernsStateToConcerns;
